PJQ.views.timecards.AddTimeCardsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'modal-manage-timecards'),
        subTemplates: {
            timecard: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'contact-timecard')
        },
        minWidth: '800px',
        timeCard: null,
        project: null,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .timecard-delete': 'deleteTimeCard',
        'click .timecards-save': 'saveTimeCards',
        'click .timecards-save-add-pq': 'saveAndAddQuantities',
        'click .timecards-continue': 'nextStep',
        'click .timecards-previous': 'previousStep',
        'click .timecards-close': 'closeAddTimeCards',
        'keyup .overtime-time, .regular-time, .doubletime-time': 'hoursChanged',
        'keyup .time-in, .time-out': 'lineItemClockChanged',
    },
    beforeModalCreated: function () {
        this.collection = new PJQ.collections.timecards.TimeCards();
        this.options.step = PJQ.constants.timecards.manageTimeCards.stage.SELECT_DATE;

        this.options.enableLineItems = this.options.settings.get('enableLineItems');

        if (this.options.project != null) {
            this.options.permissions = this.options.project.permissions ? this.options.project.permissions : PJQ.app.session.project.permissions;
        } else {
            this.options.permissions = PJQ.app.session.systemPermissions;
        }

        this.options.isAdmin = this.options.permissions.hasPermission('timeCards.isAdmin');
        this.options.canAddQuantities = this.options.permissions.hasPermission('productionQuantities.canAdd');
        if (!this.options.isAdmin) {
            this.options.contact = new PJQ.models.projectContacts.ProjectContact(PJQ.app.session.user.toJSON());
        }

        let dateNow = new Date();
        this.options.timeCardDate = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate());
        this.options.stepTotal = 4;
        if (this.options.timeCard != null) {
            this.options.project = this.options.project ? this.options.project : this.options.timeCard.get('project');
            this.collection.add(this.options.timeCard);
            this.options.timeCardDate = PJQ.helpers.dateHelpers.parseDateString(this.options.timeCard.get('date'), false);
            this.options.step = PJQ.constants.timecards.manageTimeCards.stage.MANAGE_TIMECARDS;
        } else if (this.options.project != null) {
            this.options.stepTotal -= 1;
            this.options.step = PJQ.constants.timecards.manageTimeCards.stage.SELECT_DATE;
        }

        if (!this.options.isAdmin) {
            this.options.stepTotal -= 1;
        }
    },
    beforeRender: function () {
        this.options.enableOvertime = this.options.settings.get('enableOvertime');
        this.options.enableDoubletime = this.options.settings.get('enableDoubletime');
        this.options.enableLineItems = this.options.settings.get('enableLineItems');
        this.options.enableClockIn = this.options.settings.get('enableClockIn');
    },
    renderData: function () {
        return {
            project: this.selectedProject,
            date: this.options.timeCardDate,
            settings: this.options.settings,
            stepTotal: this.options.stepTotal,
            step: this.options.step,
            enableOvertime: this.options.enableOvertime,
            enableDoubletime: this.options.enableDoubletime,
            enableLineItems: this.options.enableLineItems,
            enableClockIn: this.options.enableClockIn,
            canAddQuantities: this.options.canAddQuantities,
            isAdmin: this.options.isAdmin
        }
    },
    afterRender: function () {
        this.renderStep();
    },
    hoursChanged: function (e) {
        let $target = $(e.currentTarget).closest('.contact-timecard'),
            cid = $target.data('cid'),
            timecard = this.collection.get(cid),
            type = $(e.currentTarget).data('type'),
            minutes = PJQ.helpers.formatHelpers.minutesFromHHMM($(e.currentTarget).val());
        timecard.set(type, minutes);
    },
    renderStep: function () {
        switch (this.options.step) {
            case PJQ.constants.timecards.manageTimeCards.stage.SELECT_DATE:
                this.selectedContacts = [];
                this.timeCardDatePicker = new PJQ.inputs.Datepicker({
                    el: this.$('.timecard-date'),
                    datepickerOptions: {
                        format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                        defaultDate: this.options.timeCardDate,
                    }
                });
                break;
            case PJQ.constants.timecards.manageTimeCards.stage.SELECT_PROJECT:
                this.selectedContacts = [];
                new PJQ.views.projects.ProjectSelector({
                    el: this.$('.select-project'),
                    isSingleChoice: true,
                    onProjectSelected: _.bind(function (project) {
                        this.selectedProject = project;
                        if (project !== null) {
                            this.$('.timecards-continue').prop('disabled', (this.selectedProject === null));
                        } else {
                            this.$('.timecards-continue').prop('disabled', true);
                        }
                    }, this),
                    dataTableHeaderData: {
                        isHideDeletedFilter: true
                    }
                });
                break;
            case PJQ.constants.timecards.manageTimeCards.stage.SELECT_CONTACTS:
                this.selectedProject.fetchProjectContacts((projectContacts) => {
                    this.timeCardContactSelect = new PJQ.views.contacts.ContactsSelectInput({
                        el: this.$('.select-contacts'),
                        context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
                        saveButtonText: 'Select Contacts',
                        contacts: projectContacts,
                        isSingleChoice: false,
                        addButton: this.$('.timecards-add-contacts'),
                        onChange: _.bind(function (selectedContacts) {
                            this.selectedContacts = selectedContacts;
                            this.nextStep();
                        }, this)
                    });
                    this.timeCardContactSelect.edit();
                })
                break;
            case PJQ.constants.timecards.manageTimeCards.stage.MANAGE_TIMECARDS:
                let fnTc = () => {
                    let timecards = new PJQ.collections.timecards.TimeCards(),
                        dateNow = new Date(),
                        parameters = {
                            searchFor: '',
                            idFilter: _.size(this.selectedContacts) === 1 ? this.selectedContacts[0].id : _.map(this.selectedContacts, (contact) => {
                                return contact.id;
                            }),
                            startDate: PJQ.helpers.dateHelpers.getDateString(this.options.timeCardDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                            endDate: PJQ.helpers.dateHelpers.getDateString(this.options.timeCardDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                            page: 1,
                            pageSize: 2147483646,
                            orderBy: 'companyName',
                            orderDirection: 'asc',
                            projectId: this.selectedProject.get('projectId'),
                            timeZoneOffset: dateNow.getTimezoneOffset()
                        };

                    timecards.fetch({
                        data: parameters,
                        success: () => {
                            _.each(timecards.models, (timecard) => {
                                let contactSelected = _.find(this.selectedContacts, function (contact) {
                                    return contact.id === timecard.get('contact').id;
                                }, this) != null;

                                if (!this.collection.getTimeCard(timecard.get('id'), timecard.get('date')) && contactSelected)
                                    this.collection.add(timecard);
                            });

                            let date = this.options.timeCardDate
                            _.each(this.selectedContacts, (contact) => {
                                if (this.collection.getTimeCard(contact.get('id'), date))
                                    return;

                                if (contact.get('contactId') == null)
                                    contact.set('contactId', 0);

                                let timeCard = new PJQ.models.timecards.TimeCard({
                                    projectId: this.selectedProject.get('projectId'),
                                    id: contact.get('id'),
                                    date: PJQ.helpers.dateHelpers.parseDateString(PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE, false)),
                                    notes: '',
                                    regularHours: 0,
                                    overtimeHours: 0,
                                    doubletimeHours: 0,
                                    createdBy: -PJQ.app.session.user.id,
                                    contact: contact.attributes
                                });
                                this.collection.add(timeCard);
                            });

                            let $tcOuter = this.$('.timecard-data');
                            $tcOuter.empty();
                            _.each(this.collection.models, function (model) {
                                if (!model.get('deletedOn')) {
                                    this.renderSubTemplate(true, this.options.subTemplates.timecard, $tcOuter, {
                                        timecard: model,
                                        timecards: this.collection.models,
                                        contact: model.get('contact'),
                                        settings: this.options.settings,
                                        enableOvertime: this.options.enableOvertime,
                                        enableDoubletime: this.options.enableDoubletime,
                                        enableLineItems: this.options.enableLineItems,
                                        enableClockIn: this.options.enableClockIn,
                                        canEdit: this.options.canEdit,
                                        isAdmin: this.options.isAdmin
                                    }, _.bind(function (el) {
                                        new PJQ.Binder(el, model, {
                                            watchElements: [
                                                'textarea'
                                            ]
                                        });
                                        let fnTotal = () => {
                                            let regularHours = PJQ.helpers.formatHelpers.minutesToHHMM(model.get('regularHours')),
                                                overtimeHours = PJQ.helpers.formatHelpers.minutesToHHMM(model.get('overtimeHours')),
                                                doubletimeHours = PJQ.helpers.formatHelpers.minutesToHHMM(model.get('doubletimeHours'));

                                            if (this.options.enableClockIn) {
                                                let minutes = 0;
                                                if (this.options.enableLineItems) {
                                                    _.each(model.lineItems.models, function (lineItem) {
                                                        if (lineItem.get('timeIn') != null && lineItem.get('timeOut') != null) {
                                                            minutes += PJQ.helpers.dateHelpers.getDateMinutesDiff(new Date(lineItem.get('timeOut')), new Date(lineItem.get('timeIn')));
                                                        }
                                                    });
                                                } else if (model.get('timeIn') != null && model.get('timeOut') != null) {
                                                    minutes = PJQ.helpers.dateHelpers.getDateMinutesDiff(new Date(model.get('timeOut')), new Date(model.get('timeIn')));
                                                }

                                                regularHours = minutes > 0 ? PJQ.helpers.formatHelpers.minutesToHHMM(minutes) : '00:00'
                                            }

                                            el.find('.label-regular-hours').text(regularHours);
                                            el.find('.label-overtime-hours').text(overtimeHours);
                                            el.find('.label-doubletime-hours').text(doubletimeHours);
                                            el.find('.regular-hours').val(regularHours);
                                            el.find('.overtime-hours').val(overtimeHours);
                                            el.find('.doubletime-hours').val(doubletimeHours);
                                        };
                                        fnTotal();

                                        if (this.options.enableLineItems) {
                                            new PJQ.views.timecards.LineItemsView({
                                                el: el.find('.line-items-outer'),
                                                model: model,
                                                project: this.selectedProject,
                                                settings: this.options.settings,
                                                onLineItemChanged: () => {
                                                    fnTotal();
                                                }
                                            });
                                        } else {
                                            new PJQ.inputs.Datepicker({
                                                el: this.$('.time-in[data-cid="' + model.cid + '"]'),
                                                isTimeOnly: true,
                                                datepickerOptions: {
                                                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                                                    defaultDate: model.get('timeIn')
                                                },
                                                onChange: (value) => {
                                                    model.set('timeIn', value);
                                                    fnTotal();
                                                }
                                            });

                                            new PJQ.inputs.Datepicker({
                                                el: this.$('.time-out[data-cid="' + model.cid + '"]'),
                                                isTimeOnly: true,
                                                datepickerOptions: {
                                                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                                                    defaultDate: model.get('timeOut')
                                                },
                                                onChange: (value) => {
                                                    model.set('timeOut', value);
                                                    fnTotal();
                                                }
                                            });
                                        }
                                    }, this));
                                }
                            }, this);
                            PJQ.helpers.inputHelpers.inputMaskHours(this.$('.input-hours'));
                        }
                    });
                };
                this.selectedProject.fetchPermissions((perms) => {
                    this.options.permissions = perms;
                    if (this.options.enableLineItems) {
                        this.selectedProject.fetchSubJobs((subJobs) => {
                            this.subJobs = subJobs;
                            this.selectedProject.fetchCostCodes((costCodes) => {
                                this.costCodes = costCodes;
                                fnTc();
                            });
                        });
                    } else {
                        fnTc();
                    }
                });
                break;
        }
    },
    setStep: function (step) {
        this.options.step = step;
        this.render();
    },
    nextStep: function () {
        switch (this.options.step) {
            case PJQ.constants.timecards.manageTimeCards.stage.SELECT_DATE:
                this.options.timeCardDate = this.timeCardDatePicker.getValue();

                if (this.options.project != null && this.options.contact != null) {
                    this.selectedProject = this.options.project;
                    this.selectedContacts = [this.options.contact];
                    this.setStep(PJQ.constants.timecards.manageTimeCards.stage.MANAGE_TIMECARDS);
                } else if (this.options.project != null) {
                    this.selectedProject = this.options.project;
                    this.setStep(PJQ.constants.timecards.manageTimeCards.stage.SELECT_CONTACTS);
                } else {
                    this.setStep(PJQ.constants.timecards.manageTimeCards.stage.SELECT_PROJECT);
                }
                break;
            case PJQ.constants.timecards.manageTimeCards.stage.SELECT_PROJECT:
                let fnNextStep = () => {
                    if (this.options.contact != null) {
                        this.selectedContacts = [this.options.contact];
                        this.setStep(PJQ.constants.timecards.manageTimeCards.stage.MANAGE_TIMECARDS);
                    } else {
                        this.setStep(PJQ.constants.timecards.manageTimeCards.stage.SELECT_CONTACTS);
                    }
                }
                if (this.options.project != null && this.selectedProject.get('projectId') !== this.options.project.get('projectId')) {
                    if (this.selectedProject.get('projectId') !== this.options.project.get('projectId')) {
                        new PJQ.views.modals.YesNo({
                            header: "Confirm Project Change",
                            body: "Are you sure you want to change the Project?  Doing so will clear any data you have entered without saving.",
                            onYes: _.bind(function () {
                                this.options.project = this.selectedProject;
                                fnNextStep();
                            }, this)
                        });
                    } else {
                        fnNextStep();
                    }
                } else {
                    fnNextStep();
                }
                break;
            case PJQ.constants.timecards.manageTimeCards.stage.SELECT_CONTACTS:
                this.setStep(PJQ.constants.timecards.manageTimeCards.stage.MANAGE_TIMECARDS);
                break;
        }
    },
    previousStep: function () {
        switch (this.options.step) {
            case PJQ.constants.timecards.manageTimeCards.stage.MANAGE_TIMECARDS:
                this.setStep(this.options.contact != null ? PJQ.constants.timecards.manageTimeCards.stage.SELECT_PROJECT : PJQ.constants.timecards.manageTimeCards.stage.SELECT_CONTACTS);
                break;
            case PJQ.constants.timecards.manageTimeCards.stage.SELECT_CONTACTS:
                this.setStep(PJQ.constants.timecards.manageTimeCards.stage.SELECT_PROJECT);
                break;
            case PJQ.constants.timecards.manageTimeCards.stage.SELECT_PROJECT:
                this.setStep(PJQ.constants.timecards.manageTimeCards.stage.SELECT_DATE);
                break;
        }
    },
    addLineItem: function (e) {
        let $target = $(e.currentTarget).closest('.contact-timecard'),
            cid = $target.data('cid'),
            timecard = this.collection.get(cid),
            lineItem = new PJQ.models.timecards.TimeCardLineItem({
                timeCardId: timecard.id,
                notes: ''
            });

        timecard.lineItems.add(lineItem);
        this.render();
    },
    deleteTimeCard: function (e) {
        let $target = $(e.currentTarget).closest('.contact-timecard'),
            cid = $target.data('cid'),
            timecard = this.collection.get(cid);

        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this Time Card?",
            onDelete: _.bind(function () {
                this.collection.remove(timecard);
                this.selectedContacts = _.filter(this.selectedContacts, (contact) => {
                    return contact.id !== timecard.get('contact').id
                });
                this.render();
            }, this)
        });
    },
    deleteLineItem: function (e) {
        let $timecard = $(e.currentTarget).closest('.contact-timecard'),
            $lineItem = $(e.currentTarget).closest('.timecard-line-item'),
            timecard = this.collection.get($timecard.data('cid'));

        if (timecard) {
            let lineItem = timecard.lineItems.get($lineItem.data('cid'));

            if (lineItem) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Confirm Deletion",
                    body: "Are you sure you want to delete this Line Item?",
                    onDelete: _.bind(function () {
                        lineItem.set('delete', true);
                        timecard.set({
                            regularHours: timecard.get('regularHours') - lineItem.get('regularHours'),
                            overtimeHours: timecard.get('overtimeHours') - lineItem.get('overtimeHours'),
                            doubletimeHours: timecard.get('doubletimeHours') - lineItem.get('doubletimeHours')
                        });
                        this.render();
                    }, this)
                });
            }
        }
    },
    saveAndAddQuantities: function () {
        this.saveTimeCards(null, true);
    },
    addQuantities: function () {
        new PJQ.views.productionQuantities.TimeCardQuantitiesAddModal({
            project: this.selectedProject,
            timeCards: this.collection
        });
    },
    saveTimeCards: function (e, isAddQuantities) {
        if (_.size(this.collection.models) === 0)
            return;

        let isValid = true,
            isLineItemsValid = true,
            invalidCount = 0,
            fnSave = _.bind(function () {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'timecards',
                        },
                        {
                            endpoint: 'batch'
                        }
                    ]),
                    data: {
                        rows: this.collection.models
                    },
                    isAPIv2: true
                }).post().success(_.bind(function (data) {
                    this.collection.reset(data.rows);
                    PJQ.notifications.notify.successNotify({
                        message: 'Time Cards saved successfully'
                    });
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave();
                    }
                    this.removeModal();

                    if (isAddQuantities) {
                        this.addQuantities();
                    }
                }, this));
            }, this);

        _.each(this.collection.models, _.bind(function (model) {
            if (!model.get('deletedOn') && (model.get('regularHours') + model.get('overtimeHours') + model.get('doubletimeHours') === 0) && !this.options.enableClockIn) {
                isValid = false;
                invalidCount++;
            } else if (this.options.enableClockIn && !this.options.enableLineItems && (model.get('timeIn') == null || model.get('timeOut') == null)) {
                isValid = false;
                invalidCount++
            } else if (this.options.enableLineItems && this.options.enableClockIn) {
                _.each(model.lineItems.models, _.bind(function (lineItem) {
                    if (!lineItem.get('delete') && (lineItem.get('timeIn') == null || lineItem.get('timeOut') == null || lineItem.get('costCodeId') == null)) {
                        isLineItemsValid = false;
                    }
                }, this));
            }

            // Validate and set line items
            if (this.options.enableLineItems) {
                model.set('lineItems', model.lineItems.toJSON());
            }
        }, this));

        if (!isValid && isLineItemsValid) {
            new PJQ.views.modals.YesNo({
                header: "Time Entry Warning",
                body: invalidCount.toString() + " Time Card" + (invalidCount > 1 ? "s do" : " does") + " not have time entered.  Do you want to save anyway?",
                onYes: _.bind(function () {
                    fnSave();
                }, this)
            });
        } else if (isLineItemsValid) {
            fnSave();
        }
    },
    closeAddTimeCards: function () {
        if (this.options.step === PJQ.constants.timecards.manageTimeCards.stage.MANAGE_TIMECARDS) {
            new PJQ.views.modals.YesNo({
                header: "Unsaved Time Cards",
                body: "Unsaved Time Cards will be lost.  Are you sure you want to close without saving?",
                onYes: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});